import api from '../api/apiClient';

const OPS = '/ops/api/v1';

// User Behavior Analytics - from ops/monitoring microservice
export const getUserBehaviorAnalytics = async (params = {}) => {
  try {
    // Use ops microservice for user activity analytics
    const response = await api.get(`${OPS}/user-activity/analytics`, {
      params: {
        include_unscoped_demo: false,
        ...params
      }
    });
    return response;
  } catch (error) {
    console.error('[User Behavior Service] Error fetching analytics:', error);
    // The ops envelope's `error` is an object ({ code, message, trace_id }); passing it
    // to Error() rendered as "[object Object]".
    const data = error.response?.data;
    const wrapped = new Error(
      data?.error?.message ||
      (typeof data?.error === 'string' ? data.error : null) ||
      data?.message ||
      error.message ||
      'Failed to fetch user behavior analytics'
    );
    if (error.response) wrapped.response = error.response;
    throw wrapped;
  }
};

// User Behavior AI Summary - now from ops/monitoring microservice
export const getUserBehaviorAISummary = async (params = {}) => {
  try {
    // Use ops microservice for AI summary (generates structured summary from analytics)
    const response = await api.get(`${OPS}/user-activity/ai-summary`, {
      params: {
        include_unscoped_demo: false,
        ...params
      }
    });
    return response;
  } catch (error) {
    console.error('[User Behavior Service] Error fetching AI summary:', error);
    throw new Error(
      error.response?.data?.error ||
      error.response?.data?.message ||
      error.message ||
      'Failed to fetch AI summary'
    );
  }
};

// User Investigation - now from ops/monitoring microservice
export const getUserInvestigation = async (userId, params = {}) => {
  try {
    const response = await api.get(`${OPS}/user-activity/investigation/${userId}`, {
      params: {
        include_unscoped_demo: false,
        ...params
      }
    });
    return response;
  } catch (error) {
    console.error('[User Behavior Service] Error fetching user investigation:', error);
    throw new Error(
      error.response?.data?.error ||
      error.response?.data?.message ||
      error.message ||
      'Failed to fetch user investigation data'
    );
  }
};
